import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/Banner.png";

// ENV Values
const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const Cover = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    agree: false,
  });

  //SnackBar setup
  const closeSB = () => setSnackbar({ open: false });
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: "",
    message: "",
    color: "success",
    icon: "check",
  });

  // Send data to a backend
  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!formData.agree) {
      setSnackbar({
        open: true,
        title: "Error",
        message: "You must agree to the terms and conditions",
        color: "error",
        icon: "warning",
      });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setSnackbar({
        open: true,
        title: "Error",
        message: "Passwords do not match",
        color: "error",
        icon: "warning",
      });
      return;
    }

    // Password strength validation
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      setSnackbar({
        open: true,
        title: "Error",
        message: "La password deve contenere almeno 8 caratteri, una maiuscola, una minuscola, un numero e un carattere speciale (@$!%*?&#)",
        color: "error",
        icon: "warning",
      });
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/signup.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        setSnackbar({
          open: true,
          title: "Error",
          message: data.message || "Something went wrong",
          color: "error",
          icon: "warning",
        });
        return;
      }

      setSnackbar({
        open: true,
        title: "Success",
        message: "Welcome Aboard!",
        color: "success",
        icon: "check",
      });
      navigate("/app/authentication/sign-in");
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setSnackbar({
        open: true,
        title: "Error",
        message: error.message || "There was an error submitting the form",
        color: "error",
        icon: "warning",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="primary"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Entra nel mondo di Permessi Ok
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSignUp}>
            <MDBox mb={2}>
              <MDInput
                label="Email"
                variant="standard"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                variant="standard"
                fullWidth
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Confirm Password"
                variant="standard"
                fullWidth
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox name="agree" checked={formData.agree} onChange={handleChange} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Accetto i&nbsp;
              </MDTypography>
              <MDTypography
                component={Link}
                to="/app/legalNotice/termsAndConditions"
                variant="button"
                fontWeight="bold"
                color="primary"
                textGradient
              >
                Termini e Condizioni
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="primary" fullWidth type="submit">
                Registrati
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Hai già un Account?{" "}
                <MDTypography
                  component={Link}
                  to="/app/authentication/sign-in"
                  variant="button"
                  color="primary"
                  fontWeight="medium"
                  textGradient
                >
                  Accedi
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDSnackbar
        open={snackbar.open}
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.message}
        onClose={closeSB}
        close={closeSB}
        bgWhite
      />
    </CoverLayout>
  );
};

export default Cover;

